<template>
    <div class="project-workflow">
        <!-- 顶部项目信息 -->
        <div class="workflow-top">
            <div class="project-info">
                <span class="info-item">
                    <span class="info-label">招标项目名称：</span>
                    <span class="info-value">{{ projectName }}</span>
                </span>
                <span class="info-sep"></span>
                <span class="info-item">
                    <span class="info-label">招标项目编号：</span>
                    <span class="info-value">{{ projectCode }}</span>
                </span>
            </div>
            <el-button class="back-btn" @click="handleBack">
                <i class="el-icon-arrow-left"></i> 返回
            </el-button>
        </div>

        <!-- 流程主体 -->
        <div class="workflow-body">
            <div class="workflow-center">

                <!-- 阶段：公告发布 -->
                <div class="stage-wrap">
                    <div class="stage-pill">
                        <span class="stage-name">公告发布</span>
                    </div>
                    <div class="stage-arrow">
                        <i class="el-icon-arrow-down"></i>
                    </div>
                </div>

                <!-- 步骤列表 -->
                <div class="steps-wrap">
                    <div class="step-group" v-for="(step, index) in steps" :key="index">
                        <div
                            class="step-item"
                            :class="`step-item--${step.status}`"
                            @click="handleStepClick(step)"
                        >
                            <span class="step-name">{{ step.name }}</span>
                        </div>
                        <div class="step-arrow" v-if="index < steps.length - 1">
                            <i class="el-icon-arrow-down"></i>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjectWorkflow',

    data() {
        return {
            projectName: '',
            projectCode: '',
            steps: [
                { name: '发布招标公告', status: 'active' },
                { name: '中标候选人公示', status: 'pending' },
                { name: '中标公告', status: 'pending' }
            ]
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || '中山大厦项目'
        this.projectCode = this.$route.query.projectCode || 'E1101050893002128'
    },

    methods: {
        handleBack() {
            this.$router.push('/agentHome/semiProcess')
        },

        handleStepClick(step) {
            const query = { projectName: this.projectName, projectCode: this.projectCode }
            if (step.name === '发布招标公告') {
                this.$router.push({ path: '/agentHome/agentPublishesNotice', query })
            } else if (step.name === '中标候选人公示') {
                this.$router.push({ path: '/agentHome/candidatePublicity', query })
            } else if (step.name === '中标公告') {
                this.$router.push({ path: '/agentHome/bidWinAnnouncement', query })
            }
        }
    }
}
</script>

<style lang="less" scoped>
.project-workflow {
    background: #F2F4F7;
    min-height: 100vh;
    padding: 20px 16px;
}

// ===== 顶部 =====
.workflow-top {
    margin: 0 auto 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 4px;
    padding: 14px 20px;
}

.project-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
}

.info-item {
    font-size: 14px;
    color: #333;
}

.info-label {
    color: #606266;
}

.info-value {
    color: #303133;
    font-weight: 500;
}

.info-sep {
    width: 1px;
    height: 16px;
    background: #DCDFE6;
    margin: 0 16px;
}

.back-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #1890FF;
    border-color: #1890FF;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    padding: 8px 16px;

    i {
        font-size: 14px;
    }

    &:hover {
        background: #40A9FF;
        border-color: #40A9FF;
    }
}

// ===== 流程主体 =====
.workflow-body {
    margin: 0 auto;
    background: #fff;
    border-radius: 4px;
    padding: 40px 20px;
}

.workflow-center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

// ===== 阶段 =====
.stage-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 8px;
}

.stage-pill {
    background: rgb(0, 175, 213);
    color: #fff;
    border-radius: 50px;
    padding: 10px 48px;
    box-shadow: 0 4px 12px rgba(0, 188, 212, 0.35);
}

.stage-name {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
}

.stage-arrow {
    color: #00BCD4;
    font-size: 20px;
    margin-top: 6px;
    opacity: 0.7;
}

// ===== 步骤列表 =====
.steps-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.step-group {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.step-item {
    min-width: 220px;
    text-align: center;
    border-radius: 50px;
    padding: 12px 32px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    transition: all 0.25s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    &--completed {
        background: rgb(0, 175, 213);
        color: #fff;

    }

    &--active {
        background: rgb(0, 175, 213);
        color: #fff;

    }

    &--pending {
        background: rgb(0, 203, 178);
        color: #fff;

    }
}

.step-name {
    letter-spacing: 1px;
}

.step-arrow {
    color: #80DEEA;
    font-size: 18px;
    margin: 8px 0;
    opacity: 0.8;
}
</style>
